import { render, staticRenderFns } from "./NotificationToolbar.vue?vue&type=template&id=06b04af2&"
import script from "./NotificationToolbar.vue?vue&type=script&lang=ts&"
export * from "./NotificationToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports